import React from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames';

// Wraps AntD Tabs. When isNav is true, tabs navigate routes instead of
// switching an in-page section: activeKey is derived from the current
// route and selecting a tab calls navigate() with its route.
export const RMTabs = ({
    tabs = [],
    isNav = false,
    activeKey,
    defaultActiveKey,
    onChange,
    className,
    ...props
}) => {
    const location = useLocation();
    const navigate = useNavigate();

    const items = tabs.map(({ key, title, route }) => ({
        key: isNav ? route : key,
        label: title,
    }));

    const handleChange = (key) => {
        if (isNav) {
            navigate(key);
        }
        onChange?.(key);
    };

    return (
        <Tabs
            className={classNames('rm-tabs', className)}
            items={items}
            activeKey={isNav ? location.pathname : activeKey}
            defaultActiveKey={isNav ? undefined : defaultActiveKey}
            onChange={handleChange}
            {...props}
        />
    );
};
